import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  StyledWidgetGlobalChromecast,
  IconContainer,
  Label,
  NumberContainer,
  Number,
  UsageRateContainer,
  UsageRateLabel,
  UsageRateValue
} from './WidgetGlobalPrice.styles';

const WidgetGlobalChromecast = ({ useDistinctCount, installationCount }) => {
  const { t } = useTranslation();
  const usageRate = installationCount > 0 ? ((useDistinctCount / installationCount) * 100).toFixed(2) : 0;

  return (
    <StyledWidgetGlobalChromecast>
      <IconContainer>
        <i className="fa-light fa-screencast" />
      </IconContainer>
      <Box textAlign="start">
        <Box textAlign="start" mt={1} display={'flex'} alignItems={'baseline'} gap={1}>
          <NumberContainer>
            <Number>{installationCount}</Number>
          </NumberContainer>
          <Label>{t('statistics.chromecasts.all')}</Label>
        </Box>
        <Box textAlign="start" display={'flex'} alignItems={'baseline'} gap={1}>
          <NumberContainer>
            <Number>{useDistinctCount}</Number>
          </NumberContainer>
          <Label>{t('statistics.chromecasts.used')}</Label>
        </Box>
        <UsageRateContainer>
          <UsageRateLabel>{t('statistics.chromecasts.usageRate')}</UsageRateLabel>
          <UsageRateValue>{`${usageRate}%`}</UsageRateValue>
        </UsageRateContainer>
      </Box>
    </StyledWidgetGlobalChromecast>
  );
};

export default WidgetGlobalChromecast;
